import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../lib/api';

export interface RegisterPayload {
  email: string;
  password: string;
}

export interface RegisterResult {
  id: string;
  message: string;
}

export function useRegister() {
  const api = useApi();
  return useMutation({
    mutationFn: async ({ email, password }: RegisterPayload): Promise<RegisterResult> => {
      const { data, error, response } = (await api.POST('/auth/register' as never, {
        body: { email, password },
      } as never)) as { data?: unknown; error?: unknown; response: Response };
      if (error) {
        const err = new Error('register_failed') as Error & {
          status?: number;
          body?: unknown;
        };
        err.status = response?.status;
        err.body = error;
        throw err;
      }
      return data as RegisterResult;
    },
  });
}
